import { Capacitor } from '@capacitor/core';

/*
  EVRAK FOTOGRAFI CEKME
  ---------------------
  SORUN: uygulamada "fotograf cek" denildiginde, tarayicinin kendi
  <input type="file"> dosya secicisi aciliyordu. iOS o sirada uygulamayi
  arka plana aliyor ve bellek baskisi varsa WebView'i bosaltiyor —
  fotograf cekilip donuldugunde uygulama bastan yukleniyordu. Kullanici
  bunu "uygulama kapaniyor" olarak goruyordu.

  COZUM: Capacitor'un yerli kamera eklentisi. Kamera uygulamanin KENDI
  icinde aciliyor, WebView bosaltilmiyor, donuste hicbir sey kaybolmuyor.

  BOYUT: fotograflar 1600 piksele ve %72 kaliteye dusuruluyor. Modern bir
  telefonun ham fotografi 4-8 MB; evrak fotografi icin bu gereksiz ve
  zayif baglantida yukleme yarida kaliyordu. Kucultulmus hali 300-600 KB
  ve evrak yazisi rahat okunuyor.
*/

/*
  Yalnizca "uygulamadayiz" demek yetmiyor: site guncellendiginde
  telefondaki uygulama hala eski surum olabilir ve kamera eklentisi
  icinde bulunmayabilir. O zaman dugme gorunur ama hicbir sey yapmaz.
  isPluginAvailable eklentinin gercekten yuklu olup olmadigini soyler.
*/
export const kameraVarMi = () => {
  try {
    if (typeof Capacitor?.isNativePlatform !== 'function') return false;
    if (!Capacitor.isNativePlatform()) return false;
    if (typeof Capacitor.isPluginAvailable === 'function') {
      return Capacitor.isPluginAvailable('Camera');
    }
    return false;
  } catch (e) {
    return false;
  }
};

/** data URL -> File (yukleme kodlarinin geri kalani File bekliyor) */
const dataUrlDosya = (dataUrl, ad) => {
  const [bas, govde] = String(dataUrl).split(',');
  const tur = (bas.match(/data:(.*?);/) || [, 'image/jpeg'])[1];
  const ikili = atob(govde);
  const dizi = new Uint8Array(ikili.length);
  for (let i = 0; i < ikili.length; i += 1) dizi[i] = ikili.charCodeAt(i);
  return new File([dizi], ad, { type: tur });
};

const dosyaAdi = () => {
  const d = new Date();
  const ik = (n) => String(n).padStart(2, '0');
  return `Evrak_${d.getFullYear()}${ik(d.getMonth() + 1)}${ik(d.getDate())}`
    + `_${ik(d.getHours())}${ik(d.getMinutes())}${ik(d.getSeconds())}.jpg`;
};

/**
 * Kamerayi acar ve cekilen fotografi File olarak dondurur.
 * Kullanici vazgecerse null doner (hata degil).
 * @returns {Promise<File|null>}
 */
export const evrakFotografiCek = async () => {
  if (!kameraVarMi()) return null;
  try {
    const { Camera, CameraResultType, CameraSource } = await import('@capacitor/camera');
    const foto = await Camera.getPhoto({
      quality: 72,
      width: 1600,
      allowEditing: false,
      correctOrientation: true,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Camera,
      promptLabelHeader: 'Evrak fotoğrafı',
      promptLabelCancel: 'Vazgeç',
    });
    if (!foto?.dataUrl) return null;
    return dataUrlDosya(foto.dataUrl, dosyaAdi());
  } catch (e) {
    // Kullanici vazgectiginde de eklenti hata firlatiyor; bunu sessiz
    // geciyoruz ki ekranda gereksiz uyari cikmasin.
    return null;
  }
};

/**
 * Galeriden fotograf secer (birden fazla).
 * @returns {Promise<File[]>}
 */
export const galeridenSec = async (enFazla = 10) => {
  if (!kameraVarMi()) return [];
  try {
    const { Camera } = await import('@capacitor/camera');
    const sonuc = await Camera.pickImages({ quality: 72, width: 1600, limit: enFazla });
    const dosyalar = [];
    for (const f of sonuc?.photos || []) {
      // pickImages webPath dondurur; fetch ile blob'a ceviriyoruz.
      const cevap = await fetch(f.webPath);
      const blob = await cevap.blob();
      dosyalar.push(new File([blob], dosyaAdi(), { type: blob.type || 'image/jpeg' }));
    }
    return dosyalar;
  } catch (e) {
    return [];
  }
};
